export const init = () => {
  // TRACKER 'LOYALTY'
  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.customer.account.login
  );

  // Queued 'analyticsLoginEvent' (will be sent from loginModule.js)
  const analyticsLoginEvent = new AnalyticsQueueEvent(
    'analyticsLoginEvent',
    tracker.defaultEvent()
  );
  analyticsLoginEvent.trigger = 'click';
  analyticsLoginEvent.domContainer = '#login-form';
  analyticsLoginEvent.domElement = '.cta-v2.sign-in-button';
  analyticsLoginEvent.options.action = 'Login';
  analyticsLoginEvent.options.label = '';
  tracker.addEvent(analyticsLoginEvent);

  // Forgotten Password
  const loginForgottenPassword = new AnalyticsClickEvent(
    'loginForgottenPassword',
    tracker.defaultEvent()
  );
  loginForgottenPassword.domElement = '#linkLostPassword';
  loginForgottenPassword.options.action = 'ForgetPassword';
  loginForgottenPassword.options.label = 'Click';
  tracker.addEvent(loginForgottenPassword);

  // UN/CheckRememberMe
  const loginBoxRememberMe = new AnalyticsTriggerEvent(
    'loginBoxRememberMe',
    tracker.defaultEvent()
  );
  loginBoxRememberMe.trigger = 'change';
  loginBoxRememberMe.domElement = '#autoLogin';
  loginBoxRememberMe.getAction = $element => {
    if ($element.is(':checked')) return 'CheckRememberMe';
    return 'UncheckRememberMe';
  };
  loginBoxRememberMe.options.label = '';
  tracker.addEvent(loginBoxRememberMe);

  // Create Account With/Without ward
  const loginCreateAccount = new AnalyticsClickEvent(
    'loginCreateAccount',
    tracker.defaultEvent()
  );
  loginCreateAccount.domContainer = '.loyalty-bool';
  loginCreateAccount.domElement = '.cta';
  loginCreateAccount.getAction = $element => {
    if ($element.attr('href').indexOf('loyalty') > -1)
      return 'CreateAccountWithCard';
    return 'CreateAccountWithoutCard';
  };
  loginCreateAccount.options.label = '';
  tracker.addEvent(loginCreateAccount);

  // Create Account button
  const loginCreateAccountBtn = new AnalyticsClickEvent(
    'loginCreateAccountBtn',
    tracker.defaultEvent()
  );
  loginCreateAccountBtn.domContainer = '.m-login-panel';
  loginCreateAccountBtn.domElement = '.create-button';
  loginCreateAccountBtn.options.action = 'CreateAccount';
  loginCreateAccountBtn.options.label = '';
  tracker.addEvent(loginCreateAccountBtn);

  //US-49463 Recovery data for smart account
  const analyticsRecoveryDataEvent = new AnalyticsClickEvent(
    'analyticsRecoveryDataEvent',
    tracker.defaultEvent()
  );
  analyticsRecoveryDataEvent.domElement = '.recover-data-button';
  analyticsRecoveryDataEvent.options.action = 'RecoveryData';
  analyticsRecoveryDataEvent.options.label = '';
  tracker.addEvent(analyticsRecoveryDataEvent);

  //US-49463 Continue without login for smart account
  const analyticsContinueWithoutLoginEvent = new AnalyticsClickEvent(
    'analyticsContinueWithoutLoginEvent',
    tracker.defaultEvent()
  );
  analyticsContinueWithoutLoginEvent.domElement =
    '#continue-without-login-link';
  analyticsContinueWithoutLoginEvent.options.action = 'ContinueWithoutLogin';
  analyticsContinueWithoutLoginEvent.options.label = '';
  tracker.addEvent(analyticsContinueWithoutLoginEvent);

  // Incorrect Format Login
  const incorrectFormatLogin = new AnalyticsClickEvent(
    'incorrectFormatLogin',
    tracker.defaultEvent()
  );
  incorrectFormatLogin.trigger = 'change';
  incorrectFormatLogin.domContainer = '#login-block';
  incorrectFormatLogin.domElement = '.tel-group.form-group.has-error input';
  incorrectFormatLogin.options.action = 'ErrorMessage';
  incorrectFormatLogin.getLabel = function getLabel($element) {
    return $element[0].id;
  };
  incorrectFormatLogin.options.value = 1;
  tracker.addEvent(incorrectFormatLogin);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/login-tracker.js